module.exports = __webpack_public_path__ + "img/menu-off_01.df0e9d56.png";